const Switcher = {
    target : null,
    sections : [],
    init : function init (target) {
        this.target = target;

        [...target.getElementsByClassName('switcher__heading')].forEach((heading, index) => {
            this.sections.push({
                heading : heading,
                content : document.querySelector(`.switcher__content[data-index="${index}"]`)
            });

            if (index !== 0) {
                this.sections[index].heading.dataset.active = false;
                this.sections[index].content.dataset.active = false;
            }

            this.initEventListeners(this.sections[index].heading, index);
        });
    },
    initEventListeners : function initEvent(heading, index) {
        console.log(this.sections);
        heading.addEventListener("click", event => {
            this.clickHandler(index);
        });
    },
    clickHandler : function handleClick(index) {
        this.clearActive();
        this.sections[index].heading.dataset.active = true;
        this.sections[index].content.dataset.active = true;
    },
    clearActive : function clear() {
        this.sections.forEach((section, index) => {
            this.sections[index].heading.dataset.active = false;
            this.sections[index].content.dataset.active = false;
        })
    }
}

const switchers = [...document.getElementsByClassName('switcher')];
if (switchers)
    switchers.forEach(switcher => {
        Switcher.init(switcher);
    })